import { Helmet, HelmetData } from "react-helmet-async";
import { AI_BG_NEW, Contact_Img } from "../../../assets";
import { useState } from "react";
import toast from "react-hot-toast";
import { EMAIL_SERVICE, INTERNAL_RECIPIENTS } from "../../../utils/constants";
import { sendFormSubmissionDetails } from "../../../utils/templates";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const helmetData = new HelmetData({});

export default function ContactsPage() {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const form = new FormData(e.target);
    const payload = {
      ...Object.fromEntries(form),
    };

    try {
      //  Send submission to the team
      // INTERNAL_RECIPIENTS.forEach((user) => {
      //   const internalData = new FormData();
      //   internalData.append("to", user);
      //   internalData.append("subject", "Contact Us Form AI Global");
      //   internalData.append(
      //     "body",
      //     sendFormSubmissionDetails(payload, "Contact Us Form On AI Global")
      //   );
      //   internalData.append("messageType", "html");
      //   internalData.append("from", "no-reply@dataassistant.ai");
      //   internalData.append("senderName", "AI Global website");

      //   fetch(EMAIL_SERVICE, {
      //     method: "POST",
      //     body: internalData,
      //   });
      // });

      // 1. Fetch RSA public key
      const res = await fetch(EMAIL_SERVICE + "public-key");
      const publicKey = await res.text();

      // 2. Generate random AES key & IV
      const aesKey = CryptoJS.lib.WordArray.random(32); // 256-bit
      const iv = CryptoJS.lib.WordArray.random(16);

      const payloadData = {
        to: INTERNAL_RECIPIENTS.join(", "),
        senderName: "AI Global Website",
        from: "no-reply@dataassistant.ai",
        subject: "Contact Us Form AI Global",
        body: sendFormSubmissionDetails(payload, "Contact Us Form AI Global"),
        messageType: "html",
      };

      const encryptedPayload = CryptoJS.AES.encrypt(
        JSON.stringify(payloadData).toString(),
        aesKey,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        },
      ).toString();

      // 4. Encrypt AES key with RSA public key
      const encrypt = new JSEncrypt();

      encrypt.setPublicKey(publicKey);
      const encryptedAesKey = encrypt.encrypt(
        aesKey.toString(CryptoJS.enc.Base64),
      );

      if (!encryptedPayload) {
        throw new Error("Failed to encrypt message. Please try again later.");
      }

      // Send encrypted payload to email service
      const response = await fetch(EMAIL_SERVICE + "send/encrypted", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          encryptedAesKey,
          iv: iv.toString(CryptoJS.enc.Base64),
          encryptedPayload,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send encrypted email");
      }

      handleSuccess(
        "🎉 We’ve received your message and will get back to you soon.",
      );
      e.target.reset();
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSuccess = (message) => {
    toast.dismiss();
    toast.success(message, {
      duration: 3000,
      position: "top-center",
      style: {
        background: "#2F4171",
        color: "#fff",
        fontWeight: "bold",
      },
    });
  };

  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Contact Analytics Intelligence Ltd | Global Enterprise AI &amp; Analytics</title>
        <link rel="canonical" href="https://analyticsintelligence.com/contact" />
        <meta
          name="description"
          content="Get in touch with Analytics Intelligence Ltd for enterprise AI, banking analytics, fintech AI solutions, or global partnership opportunities. We serve organisations across Africa, the UK, Europe, North America, and beyond."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence contact, Analytics Intelligence Ltd, Analytics Intelligence Mauritius, contact enterprise AI company, enterprise AI partnership, data analytics consulting, AI for banking contact, fintech AI solutions contact, AI company in Mauritius contact, data analytics company in Africa contact, banking AI SSA, business inquiries, AI services contact"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Analytics Intelligence Ltd" />
        <meta property="og:title" content="Contact Analytics Intelligence Ltd | Global Enterprise AI & Analytics" />
        <meta property="og:description" content="Get in touch with Analytics Intelligence Ltd for enterprise AI, banking analytics, and fintech AI solutions — serving organisations worldwide." />
        <meta property="og:url" content="https://analyticsintelligence.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://analyticsintelligence.com/favicon.png" />
        <meta property="og:site_name" content="Analytics Intelligence" />
        <meta property="og:locale" content="en_GB" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@_AnalyticsIntel" />
        <meta name="twitter:title" content="Contact Analytics Intelligence Ltd | Global Enterprise AI & Analytics" />
        <meta name="twitter:description" content="Get in touch with Analytics Intelligence Ltd for enterprise AI, banking analytics, and fintech AI solutions — serving organisations worldwide." />
        <meta name="twitter:image" content="https://analyticsintelligence.com/favicon.png" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Analytics Intelligence Ltd",
            "description": "Contact Analytics Intelligence Ltd for enterprise AI solutions, banking analytics, fintech AI, and partnership opportunities.",
            "url": "https://analyticsintelligence.com/contact",
            "publisher": {
              "@type": "Organization",
              "name": "Analytics Intelligence Ltd",
              "url": "https://analyticsintelligence.com",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Port Louis",
                "addressCountry": "MU"
              }
            }
          }
        `}</script>
      </Helmet>

      <main>
        <section
          style={{
            backgroundImage: `url("${AI_BG_NEW}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className="min-h-[95vh] flex items-center"
        >
          <div className="container mx-auto w-full h-full flex flex-col gap-16 pt-[96px] md:pt-[15rem] pb-[96px]">
            <div className="flex flex-col items-center gap-4">
              <h2 className="text-[36px] md:text-[48px] text-center md:text-left font-extrabold leading-[1.3] md:leading-[54px] text-white">
                Contact Us
              </h2>

              <p className="text-sm md:text-lg text-center font-medium text-[#E3E3E3] leading-5 md:max-w-[1200px]">
                Get in touch with us for any inquiries or support regarding
                Analytics Intelligence.
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-11 bg-[#FFFFFF0D] p-4 md:p-16">
              <div className="basis-full md:basis-2/4 flex items-center justify-center">
                <img
                  src={Contact_Img}
                  alt="Vision and Mission"
                  className="w-full max-w-[400px] h-auto"
                />
              </div>

              <div className="w-full basis-full md:basis-2/4 space-y-4 flex items-center justify-center ">
                <form
                  onSubmit={handleSubmit}
                  className="w-full max-w-full md:max-w-lg space-y-[36px]"
                >
                  {/* Name */}
                  <div className="flex flex-col gap-3">
                    <label
                      htmlFor="name"
                      className="block font-bold text-white"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter name"
                      className="w-full rounded-md bg-[#FFFFFF33] border border-[#FFFFFF66] px-2 md:px-6 py-3 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  {/* Email */}
                  <div className="flex flex-col gap-3">
                    <label
                      htmlFor="email"
                      className="block font-bold text-white"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter email"
                      className="w-full rounded-md bg-[#FFFFFF33] border border-[#FFFFFF66] px-2 md:px-6 py-3 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  {/* Message */}
                  <div className="flex flex-col gap-3">
                    <label
                      htmlFor="message"
                      className="block font-bold text-white"
                    >
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      placeholder="Type message here"
                      className="w-full rounded-md bg-[#FFFFFF33] border border-[#FFFFFF66] px-6 py-3 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  {/* Submit button */}
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-full rounded-full btn-sweep btn-sweep-blue text-white py-3 font-semibold"
                  >
                    {submitting ? "Submitting...." : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
